import React, { useState } from 'react';
import axios from "axios"
import { User, Lock, Sun, Moon } from 'lucide-react';
import { nameLocal } from '../utils/storage';
import { getTheme, toggleTheme } from '../utils/theme';
import logo from "../assets/logos/logo-fin.png";

const Login = () => {
    const [error, setError] = useState("")
    const [load, setLoad] = useState(false)
    const [theme, setThemeState] = useState(getTheme())
    const [credentials, setCredentials] = useState({ email: "", password: "" })

    const switchTheme = () => setThemeState(toggleTheme())

    const submit = async (e) => {
        e && e.preventDefault()
        if (load) return
        setLoad(true)
        const { email, password } = credentials;
        if (email && password) {
            try {
                const response = await axios.post(process.env.REACT_APP_API_URL + "/auth/login", { email, password });
                if (response?.status == 200 && response?.data?.token) {
                    localStorage.setItem(nameLocal.token, response.data.token)
                    window.location.href = "/"
                } else {
                    setError(response?.data?.message)
                }
            } catch (err) {
                setError(err?.response?.data?.message || "La connexion a échoué")
            }
            setLoad(false)
            return;
        }
        setLoad(false)
        setError('Remplir les champs')
    }

    return (
        <div className='login-screen'>
            <button type='button' className='login-theme-toggle' onClick={switchTheme} aria-label="Thème">
                {theme === 'light' ? <Moon size={20} /> : <Sun size={20} />}
            </button>

            <form className='login-box' onSubmit={submit}>
                <div className='login-head df aic jcc gap1'>
                    <img src={logo} alt="Empire" className='login-logo' />
                    <p className='login-title'>SIGN IN</p>
                </div>

                <div className='login-field'>
                    <User size={18} className='login-ic' />
                    <input
                        type='email'
                        placeholder='Email'
                        value={credentials.email}
                        onChange={(e) => setCredentials({ ...credentials, email: e.currentTarget.value })} />
                </div>

                <div className='login-field'>
                    <Lock size={18} className='login-ic' />
                    <input
                        type='password'
                        placeholder='Mot de passe'
                        value={credentials.password}
                        onChange={(e) => setCredentials({ ...credentials, password: e.currentTarget.value })} />
                </div>

                {error && <p className='login-err'>{error}</p>}

                <button type='submit' className='login-btn'>
                    {load ? <span className='loader sm'></span> : "LOGIN"}
                </button>
            </form>
        </div>
    );
};

export default Login;
